const FIXED_KEY_HEX = "77214d4b196a87cd520045fd20a51d67";
const ACTIVATION_BYTES_HEX_LENGTH = 8;
const HASH_COMPONENT_LENGTH = 16;
const HASH_ALGORITHM = "SHA-1";

function hexToBytes(hex: string): Uint8Array {
  return Uint8Array.from(hex.match(/.{2}/g) ?? [], (byte) => Number.parseInt(byte, 16));
}

function bytesToHex(bytes: Uint8Array): string {
  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
}

function concatenateBytes(...values: Uint8Array[]): Uint8Array {
  const resultLength = values.reduce((length, value) => length + value.length, 0);
  const result = new Uint8Array(resultLength);
  let offset = 0;

  for (const value of values) {
    result.set(value, offset);
    offset += value.length;
  }

  return result;
}

async function sha1(value: Uint8Array): Promise<Uint8Array> {
  const digest = await globalThis.crypto.subtle.digest(HASH_ALGORITHM, value);
  return new Uint8Array(digest);
}

export function isValidActivationBytes(value: string): boolean {
  return new RegExp(`^[0-9a-fA-F]{${ACTIVATION_BYTES_HEX_LENGTH}}$`).test(value.trim());
}

export async function calculateAudibleChecksum(activationBytes: string): Promise<string> {
  const normalizedActivationBytes = activationBytes.trim().toLowerCase();
  if (!isValidActivationBytes(normalizedActivationBytes)) {
    throw new Error("Activation bytes must contain exactly 8 hexadecimal characters.");
  }

  const fixedKey = hexToBytes(FIXED_KEY_HEX);
  const activationBytesValue = hexToBytes(normalizedActivationBytes);
  const intermediateKey = await sha1(concatenateBytes(fixedKey, activationBytesValue));
  const intermediateIv = await sha1(
    concatenateBytes(fixedKey, intermediateKey, activationBytesValue)
  );
  const checksumInput = concatenateBytes(
    intermediateKey.slice(0, HASH_COMPONENT_LENGTH),
    intermediateIv.slice(0, HASH_COMPONENT_LENGTH)
  );

  return bytesToHex(await sha1(checksumInput));
}
